<form
  class="form"
  autocomplete="off"
  [formGroup]="messageForm"
  (ngSubmit)="submit()"
>
  <h2 mat-dialog-title>{{ "contact" | translate }}</h2>
  <mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ "name" | translate }}</mat-label>
        <input
          appInputRestriction="name"
          type="text"
          matInput
          placeholder="{{ 'enter_your_name' | translate }}"
          formControlName="nombre"
          [maxlength]="50"
        />
        <mat-error *ngIf="messageForm.get('nombre')!.invalid">
          {{ "invalid_name" | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ "email_address" | translate }}</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ 'enter_your_email_address' | translate }}"
          appInputRestriction="email"
          formControlName="correo"
          [maxlength]="50"
        />
        <mat-error *ngIf="messageForm.get('correo')!.invalid">
          {{ "invalid_email_address" | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ "phone" | translate }}</mat-label>
        <input
          type="text"
          matInput
          mask="000 000 0000 99999"
          formControlName="telefono"
          [maxlength]="15"
        />
        <mat-error *ngIf="messageForm.get('telefono')!.invalid">
          {{ "invalid_phone_number" | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ "message" | translate }}</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ 'enter_your_message' | translate }}"
          appInputRestriction="text"
          formControlName="mensajeEnviar"
          [maxlength]="400"
        />
        <mat-error *ngIf="messageForm.get('mensajeEnviar')!.invalid">
          {{ "enter_your_message" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="mt-3">
    <button mat-flat-button type="button" mat-dialog-close>
      {{ "cancel" | translate }}
    </button>
    <button mat-flat-button color="primary" type="submit">
      {{ "send" | translate }}
    </button>
  </mat-dialog-actions>
</form>
